import React from 'react';
import { cmsAssetPath } from 'bv';
import classNames from 'classnames';
import { numberLogosFirstRowMobile, partnerLogos } from 'footer-config';

const PartnerLogos = () => (
  <div className="partner-logos">
    {
      partnerLogos.map((partnerLogo, i) => (
        <a
          key={partnerLogo}
          className={classNames('partner-logos__logo', {
            'partner-logos__logo--order-1': numberLogosFirstRowMobile && numberLogosFirstRowMobile <= i,
          })}
          style={{ backgroundImage: `url(${cmsAssetPath(partnerLogo.image)})` }}
          {... partnerLogo.url ? { href: partnerLogo.url, target: '_blank' } : {}}
        />
      ))
    }
  </div>
);

export default PartnerLogos;
